export default "__VITE_ASSET__DvINe0sL__"